import React from 'react';
import {useTranslation} from 'react-i18next';
import AllNotifications from './parts/AllNotifications';
import PageHeader from '../../components/common/header/PageHeader';

function NotificationsPage(): JSX.Element {
    const {t} = useTranslation();

    return (
        <div className="l-container">
            <PageHeader title={t('navigation.notifications')} />
            <AllNotifications />
        </div>
    );
}

export default NotificationsPage;
